import { FiChevronRight } from 'react-icons/fi';

const FeaturedGroup = ({ onClick, group }) => {
  if (!group) return null;

  return (
    <div
      className='t-flex t-items-center t-justify-between t-gap-2 t-overflow-hidden t-cursor-pointer t-rounded-xl t-border-x t-border-y t-border-neutrals-light-grey t-p-4 [&_*]:t-cursor-pointer hover:t-bg-neutral-100 t-transition t-duration-200 t-h-14'
      onClick={() => onClick('artwork.42')}>
      <div className='t-flex t-gap-4 t-items-center'>
        <p className='t-mb-0 t-w-full t-text-xs t-font-bold t-text-brand-black t-whitespace-nowrap'>
          {group.groupName}
        </p>

        <span className='t-bg-[#CB3F00] t-text-white t-rounded-[3px] t-px-3 t-py-[1px] t-text-[10px] t-uppercase t-font-body'>
          Featured
        </span>
      </div>

      <div className='t-flex t-h-[36px] t-w-[36px] t-items-center t-justify-end'>
        <FiChevronRight size={24} className='t-text-brand-black' />
      </div>
    </div>
  );
};

export default FeaturedGroup;
